<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('integration.historyBreadcrumb')"
      :title="$t('integration.historyTitle')"
    >
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration', [])"
              v-if="filterData.integration.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration.length > 0">
                  {{ filterData.integration[0].name }}

                  <template v-if="filterData.integration.length > 1">
                    +{{ filterData.integration.length - 1 }}
                  </template>
                </template>
                <template v-else> Integrations </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_integration" placeholder="Search Integration" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'integration',
                      getCheckList('integrationList', 'search_integration', 'name', 'integration'),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('integration', item)"
                  v-for="item in getCheckList(
                    'integrationList',
                    'search_integration',
                    'name',
                    'integration',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('exclude_integration', [])"
              v-if="filterData.exclude_integration.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.exclude_integration.length > 0">
                  {{ filterData.exclude_integration[0].name }}

                  <template v-if="filterData.exclude_integration.length > 1">
                    +{{ filterData.exclude_integration.length - 1 }}
                  </template>
                </template>
                <template v-else> Exclude Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_exclude_integration" placeholder="Search Integration" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.exclude_integration"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('exclude_integration', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'exclude_integration',
                      getCheckList(
                        'integrationList',
                        'search_exclude_integration',
                        'name',
                        'exclude_integration',
                      ),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('exclude_integration', item)"
                  v-for="item in getCheckList(
                    'integrationList',
                    'search_exclude_integration',
                    'name',
                    'exclude_integration',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('client', [])"
              v-if="filterData.client.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.client.length > 0">
                  {{ filterData.client[0].name }}

                  <template v-if="filterData.client.length > 1">
                    +{{ filterData.client.length - 1 }}
                  </template>
                </template>
                <template v-else> Clients </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_client" placeholder="Search Client" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.client"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('client', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'client',
                      getCheckList('clientList', 'search_client', 'name', 'client'),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('client', item)"
                  v-for="item in getCheckList('clientList', 'search_client', 'name', 'client')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('countries', [])"
              v-if="filterData.countries.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.countries.length > 0">
                  {{ filterData.countries[0].enName }}

                  <template v-if="filterData.countries.length > 1">
                    +{{ filterData.countries.length - 1 }}
                  </template>
                </template>
                <template v-else> Countries </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_countries" placeholder="Search Countries" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.countries"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('countries', item)"
                  >
                    {{ item.enName }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'countries',
                      getCheckList('countriesList', 'search_countries', 'enName', 'countries'),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('countries', item)"
                  v-for="item in getCheckList(
                    'countriesList',
                    'search_countries',
                    'enName',
                    'countries',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.enName }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('languages', [])"
              v-if="filterData.languages.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.languages.length > 0">
                  {{ filterData.languages[0].code }}

                  <template v-if="filterData.languages.length > 1">
                    +{{ filterData.languages.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_languages" placeholder="Search Languages" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.languages"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('languages', item)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'languages',
                      getCheckList('languagesList', 'search_languages', 'code', 'languages'),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('languages', item)"
                  v-for="item in getCheckList(
                    'languagesList',
                    'search_languages',
                    'code',
                    'languages',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration_type', [])"
              v-if="filterData.integration_type.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration_type.length > 0">
                  {{ filterData.integration_type[0].name }}

                  <template v-if="filterData.integration_type.length > 1">
                    +{{ filterData.integration_type.length - 1 }}
                  </template>
                </template>
                <template v-else> Type Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration_type"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration_type', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addAllCheckElement('integration_type', integrationSpecialTypeList)"
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('integration_type', item)"
                  v-for="item in integrationSpecialTypeList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!bayer" class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('bayer', [])"
              v-if="filterData.bayer.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.bayer.length > 0">
                  {{ filterData.bayer[0].name }}

                  <template v-if="filterData.bayer.length > 1">
                    +{{ filterData.bayer.length - 1 }}
                  </template>
                </template>
                <template v-else> Bayer </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_bayer" placeholder="Search Bayer" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.bayer"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('bayer', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="
                    addAllCheckElement(
                      'bayer',
                      getCheckList('bayerList', 'search_bayer', 'name', 'bayer'),
                    )
                  "
                  class="check-selector__list-item all"
                >
                  Add all
                </div>
                <div
                  @click="addCheckElement('bayer', item)"
                  v-for="item in getCheckList('bayerList', 'search_bayer', 'name', 'bayer')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.date_from" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.date_to" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-presets">
          <div
            v-for="preset in periodPresets"
            :key="preset.key"
            @click="applyPeriodPreset(preset.key)"
            :class="['list__filter-preset', isPeriodPreset(preset.key) && 'active']"
          >
            {{ preset.name }}
          </div>
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
        <div
          @click="favoriteSwitch"
          :class="['list__filter-favorite', filterData.is_favorite && 'active']"
        >
          Favorite Integrations
          <template>({{ getCountFavorite() }})</template>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25px"
            height="25px"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              class="inner"
              d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
              fill="none"
            />
            <path
              class="border"
              d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
              stroke="#000000"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <div class="list__tab-container">
        <div class="list__tab">
          <div
            @click="handleTabChange('default')"
            :class="['list__tab-item', tab == 'default' && 'active']"
          >
            Default
          </div>
          <div
            @click="handleTabChange('integration')"
            :class="['list__tab-item', tab == 'integration' && 'active']"
          >
            Integration
          </div>
          <div
            @click="handleTabChange('date')"
            :class="[
              'list__tab-item',
              tab == 'date' && 'active',
              !filterData.date_from && !filterData.date_to && 'disable',
            ]"
          >
            Date
          </div>
        </div>
        <div v-if="tab == 'default'" class="list__count-element">
          Element - {{ integrationHistoryList.length }}
        </div>
        <div v-if="tab == 'integration'" class="list__count-element">
          Element - {{ tabIntegrationList.length }}
        </div>
        <div v-if="tab == 'date'" class="list__count-element">
          Element - {{ tabDateList.length }}
        </div>
      </div>

      <div v-if="tab == 'default'">
        <div class="list">
          <div v-if="integrationHistoryList.length">
            <CustomTable
              v-if="integrationHistoryList.length"
              :data="integrationHistoryList"
              :deleted-keys="tableOptions.deletedKeys"
              :rename-columns="tableOptions.renameColumn"
              :custom-order="tableOptions.customOrder"
              :is-action-block-visible="tableOptions.isActionBlockVisible"
              :handleFilter="handleFilter"
              :direction="directionSort"
              :order="orderSort"
              :name="'integrationHistory'"
            >
              <template v-slot:extra>
                <div class="custom-table__row row-total total">
                  <div class="custom-table__row-item"><b>Total</b></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item"></div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.remaining }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendCapacity }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendCapacityDuplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendCounter }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendSuccess }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendSuccessDuplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendDuplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.sendError }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.ftd }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.ftdMtm }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.cr }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ integrationHistory.statistic.crMtm }}
                  </div>
                  <div class="custom-table__row-item">
                    {{
                      integrationHistory.statistic.sendSuccess +
                      integrationHistory.statistic.sendSuccessDuplicate
                    }}
                  </div>
                  <div class="custom-table__row-item"></div>
                </div>
              </template>
            </CustomTable>
            <div class="pagination">
              <Pagination
                :maxPage="integrationHistory.lastPage"
                :page="page"
                :urlList="'INTEGRATION_HISTORY'"
                :totalItem="integrationHistory.total"
                :queryParams="getQueryParameters"
              />
            </div>
          </div>
          <div class="list__no-have" v-else>No History found by this parameter.</div>
        </div>
      </div>

      <div v-if="tab == 'integration'">
        <div class="list integration-tab integration-tab--valid">
          <div v-if="tabIntegrationList.length">
            <CustomTable
              v-if="tabIntegrationList.length"
              :data="tabIntegrationList"
              :deleted-keys="tableOptionsIntegration.deletedKeys"
              :rename-columns="tableOptionsIntegration.renameColumn"
              :custom-order="tableOptionsIntegration.customOrder"
              :is-action-block-visible="tableOptionsIntegration.isActionBlockVisible"
              :handleFilter="handleFilter"
              :direction="directionSort"
              :order="orderSort"
              :name="'integrationHistory'"
            >
              <template v-slot:extra>
                <div class="custom-table__row row-total total">
                  <div class="custom-table__row-item"><b>Total</b></div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.remaining }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_capacity }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_capacity_duplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_counter }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_success }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_success_duplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_duplicate }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.send_error }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.ftd }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.ftd_mtm }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.cr }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.cr_mtm }}
                  </div>
                  <div class="custom-table__row-item">
                    {{
                      tabIntegrationTotal.send_success + tabIntegrationTotal.send_success_duplicate
                    }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.valid }}
                  </div>
                  <div class="custom-table__row-item">
                    {{ tabIntegrationTotal.valid_percent }}
                  </div>
                </div>
              </template>
            </CustomTable>

            <details class="valid-explain">
              <summary class="valid-explain__title">
                {{ $t("integration.validExplainTitle") }}
              </summary>
              <p class="valid-explain__text">
                {{ $t("integration.validExplain") }}
              </p>
              <div
                v-for="item in tabIntegrationList"
                :key="item.integration_id"
                class="valid-explain__row"
              >
                <b>{{ item.integration_id }}</b>
                <span v-if="!item.valid_statuses_list.length" class="valid-explain__muted">
                  {{ $t("integration.validNotConfigured") }}
                </span>
                <span v-else>
                  {{ $t("integration.validList", { list: item.valid_statuses_list.join(", ") }) }}
                </span>
                <span v-if="item.partner_statuses_list.length" class="valid-explain__statuses">
                  <span
                    v-for="st in item.partner_statuses_list"
                    :key="st.status"
                    :class="['valid-explain__status', st.isValid && 'valid']"
                    >{{ st.status }}: {{ st.count }}</span
                  >
                </span>
              </div>
            </details>
          </div>
          <div class="list__no-have" v-else>No History found by this parameter.</div>
        </div>
      </div>

      <div v-if="tab == 'date'">
        <div class="list integration-tab">
          <div v-if="tabDateList.length">
            <CustomTable
              v-if="tabDateList.length"
              :data="tabDateList"
              :deleted-keys="tableOptionsDate.deletedKeys"
              :rename-columns="tableOptionsDate.renameColumn"
              :custom-order="tableOptionsDate.customOrder"
              :is-action-block-visible="tableOptionsDate.isActionBlockVisible"
              :handleFilter="handleFilter"
              :direction="directionSort"
              :order="orderSort"
              :name="'integrationHistory'"
            >
            </CustomTable>
          </div>
          <div class="list__no-have" v-else>No History found by this parameter.</div>
        </div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import userApi from "~/api/user";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "IntegrationHistoryList",
  metaInfo() {
    return {
      title: this.$t("integration.historyTitle"),
    };
  },
  data() {
    return {
      admin: false,
      team_lead: false,
      bayer: false,

      // по умолчанию — сгруппированно по интеграциям, а не построчно по дням
      tab: "integration",

      periodPresets: [
        { key: "last_week", name: this.$t("integration.lastWeek") },
        { key: "this_week", name: this.$t("integration.thisWeek") },
        { key: "last_month", name: this.$t("integration.lastMonth") },
      ],
      directionSort: false,
      orderSort: "id",

      tabIntegrationList: [],
      tabIntegrationTotal: {
        send_counter: 0,
        send_capacity: 0,
        send_success: 0,
        send_duplicate: 0,
        send_error: 0,
        send_capacity_duplicate: 0,
        send_success_duplicate: 0,
        remaining: 0,
      },
      tabDateList: [],

      search_integration: "",
      search_exclude_integration: "",
      search_client: "",
      search_countries: "",
      search_languages: "",
      search_bayer: "",

      filterData: {
        integration_type: [],
        integration: [],
        exclude_integration: [],
        client: [],
        date_from: null,
        date_to: null,
        countries: [],
        languages: [],
        is_favorite: false,
        bayer: [],
      },
      isFilter: false,
      clientList: [],
      integrationList: [],
      countriesList: [],
      languagesList: [],
      bayerList: [],

      integrationSpecialTypeList: [
        {
          name: this.$t("common.all"),
          id: "all",
        },
        {
          name: "In",
          id: "in",
        },
        {
          name: "Out",
          id: "out",
        },
      ],

      tableOptions: {
        deletedKeys: ["is_active", "is_favorite"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "integration_id",
            to: "Integration",
          },
          {
            from: "client_id",
            to: "Client",
          },
          {
            from: "send_counter",
            to: "Sent",
          },
          {
            from: "send_capacity",
            to: "CAP",
          },
          {
            from: "send_capacity_duplicate",
            to: "CAP Dup",
          },
          {
            from: "send_success",
            to: "Success",
          },
          {
            from: "send_success_duplicate",
            to: "Success Dup",
          },
          {
            from: "send_duplicate",
            to: "Non-unique",
          },
          {
            from: "send_error",
            to: "Error",
          },
          {
            from: "imported_date",
            to: "Imported Date",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_mtm",
            to: "FTD Mtm",
          },
          {
            from: "cr",
            to: "CR",
          },
          {
            from: "cr_mtm",
            to: "CR Mtm",
          },
          {
            from: "success_sum",
            to: "Success sum",
          },
        ],
        customOrder: [
          "id",
          "integration_id",
          "client_id",
          "remaining",
          "send_capacity",
          "send_capacity_duplicate",
          "send_counter",
          "send_success",
          "send_success_duplicate",
          "send_duplicate",
          "send_error",
          "ftd",
          "ftd_mtm",
          "cr",
          "cr_mtm",
          "success_sum",
          "imported_date",
          "is_favorite",
        ],
      },

      tableOptionsIntegration: {
        deletedKeys: ["is_active", "is_favorite"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "integration_id",
            to: "Integration",
          },
          {
            from: "send_counter",
            to: "Sent",
          },
          {
            from: "send_capacity",
            to: "CAP",
          },
          {
            from: "send_capacity_duplicate",
            to: "CAP Dup",
          },
          {
            from: "send_success",
            to: "Success",
          },
          {
            from: "send_success_duplicate",
            to: "Success Dup",
          },
          {
            from: "send_duplicate",
            to: "Non-unique",
          },
          {
            from: "send_error",
            to: "Error",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_mtm",
            to: "FTD Mtm",
          },
          {
            from: "cr",
            to: "CR",
          },
          {
            from: "cr_mtm",
            to: "CR Mtm",
          },
          {
            from: "success_sum",
            to: "Success sum",
          },
          {
            from: "valid",
            to: "Valid",
          },
          {
            from: "valid_percent",
            to: "% Valid",
          },
        ],
        customOrder: [
          "integration_id",
          "remaining",
          "send_capacity",
          "send_capacity_duplicate",
          "send_counter",
          "send_success",
          "send_success_duplicate",
          "send_duplicate",
          "send_error",
          "ftd",
          "ftd_mtm",
          "cr",
          "cr_mtm",
          "success_sum",
          "valid",
          "valid_percent",
          "is_favorite",
        ],
      },

      tableOptionsDate: {
        deletedKeys: ["is_active", "is_favorite"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "date",
            to: "Date",
          },
          {
            from: "send_counter",
            to: "Sent",
          },
          {
            from: "send_capacity",
            to: "CAP",
          },
          {
            from: "send_capacity_duplicate",
            to: "CAP Dup",
          },
          {
            from: "send_success",
            to: "Success",
          },
          {
            from: "send_success_duplicate",
            to: "Success Dup",
          },
          {
            from: "send_duplicate",
            to: "Non-unique",
          },
          {
            from: "send_error",
            to: "Error",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_mtm",
            to: "FTD Mtm",
          },
          {
            from: "cr",
            to: "CR",
          },
          {
            from: "cr_mtm",
            to: "CR Mtm",
          },
          {
            from: "success_sum",
            to: "Success sum",
          },
        ],
        customOrder: [
          "date",
          "remaining",
          "send_capacity",
          "send_capacity_duplicate",
          "send_counter",
          "send_success",
          "send_success_duplicate",
          "send_duplicate",
          "send_error",
          "ftd",
          "ftd_mtm",
          "cr",
          "cr_mtm",
          "success_sum",
          "is_favorite",
        ],
      },

      formDataToSend: {
        name: "",
        is_active: true,
        type_id: null,
        language_id: null,
        client: null,
        send_frequency: "* * * * *",
        send_capacity: "",
        country_ids: {},
        api_key: "",
        api_url: "",
        map_id: "",
        send_capacity_duplicate: "",
        lead_fresh_time: "",
        send_work_time: {
          all: [
            { HH: "09", mm: "00" },
            { HH: "18", mm: "00" },
          ],
          days: {
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: [],
            sun: [],
          },
        },
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    ModalError,
    // MainSelect,
    DatePicker,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);

    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }

      if (this.user.groups[0].id == 2 || this.user.groups[0].id == 5) {
        this.canDelete = true;
      }
    }

    this.getClient();
    this.getIntegration();
    this.getCountry();
    this.getLanguage();
    this.setQueryParams();
    this.getBayer();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", [
      "error",
      "loadingProcess",
      "integrationHistory",
      "integrationHistoryList",
    ]),
    page() {
      return +this.$route.params.page;
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    async getBayer() {
      await userApi
        .getBayerAll()
        .then((res) => {
          this.bayerList = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    getCheckList(listKey, filterKey, nameKey, chooseItem) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      // список выбранных id
      const selectedIds = Array.isArray(this.filterData[chooseItem])
        ? this.filterData[chooseItem].map((item) => item?.id)
        : [];

      const filterStr =
        rawFilter == null || String(rawFilter).trim() === ""
          ? null
          : String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        // ❌ исключаем если id уже выбран
        if (selectedIds.includes(item?.id)) return false;

        // если фильтра нет — возвращаем всё кроме выбранных
        if (!filterStr) return true;

        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `?page=${this.page}&perPage=20&with[0]=client&with[1]=integration`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      if (this.isFilter) {
        if (this.filterData.integration.length > 0) {
          const ids = this.filterData.integration;
          ids.forEach((item, index) => {
            url += `&integration_id[${index}]=${item.id}`;
          });
        }

        if (this.filterData.bayer.length > 0) {
          const ids = this.filterData.bayer;
          const idsArray = [];
          ids.forEach((item, index) => {
            url += `&buyer_id[${index}]=${item.id}`;
          });
        }

        if (this.filterData.exclude_integration.length > 0) {
          const ids = this.filterData.exclude_integration;
          ids.forEach((item, index) => {
            url += `&exclude_integration_id[${index}]=${item.id}`;
          });
        }

        if (this.filterData.countries.length > 0) {
          const ids = this.filterData.countries;
          ids.forEach((item, index) => {
            url += `&countries[${index}]=${item.id}`;
          });
        }

        if (this.filterData.languages.length > 0) {
          const ids = this.filterData.languages;
          ids.forEach((item, index) => {
            url += `&languages[${index}]=${item.id}`;
          });
        }

        if (this.filterData.client.length > 0) {
          const ids = this.filterData.client;
          ids.forEach((item, index) => {
            url += `&client_id[${index}]=${item.id}`;
          });
        }

        if (this.filterData.integration_type.length > 0) {
          const ids = this.filterData.integration_type;
          const idsArray = [];
          ids.forEach((item, index) => {
            idsArray.push(item.id);
          });
          ids.forEach((item, index) => {
            url += `&integration_type[${index}]=${item.id}`;
          });
        }

        if (this.filterData.date_from) {
          url += `&date_from=${moment(this.filterData.date_from).format("YYYY-MM-DD")}`;
        }

        if (this.filterData.date_to) {
          url += `&date_to=${moment(this.filterData.date_to).format("YYYY-MM-DD")}`;
        }
      }

      const local = JSON.parse(localStorage.getItem("favorite_integration") || "[]");
      const switchFavorite = JSON.parse(
        localStorage.getItem("favorite_integration_switch") || "false",
      );

      this.filterData.is_favorite = switchFavorite;

      if (switchFavorite && this.filterData.integration.length == 0) {
        if (local.length > 0) {
          local.forEach((item, index) => {
            url += `&integration_id[${index}]=${item}`;
          });
        } else {
          return;
        }
      }

      this.$store.commit("lead/setLoading", true);

      leadApi
        .getIntegrationHistoryList(url)
        .then((res) => {
          this.$store.commit("lead/setError", {});
          this.$store.commit("lead/setValidationErrors", {});

          const integrations = res.data.data;
          for (let i = 0; integrations.length > i; i++) {
            integrations[i].imported_date = moment(integrations[i].importedDate).format(
              "DD.MM.YYYY HH:mm",
            );
            integrations[i].ftd_mtm = integrations[i].ftdMtm;
            integrations[i].cr_mtm = integrations[i].crMtm;
            integrations[i].success_sum =
              integrations[i].sendSuccess + integrations[i].sendSuccessDuplicate;

            integrations[i].client_id = integrations[i].client.name;
            integrations[i].integration_id = integrations[i].integration.name;
            integrations[i].send_counter = integrations[i].sendCounter;
            integrations[i].send_capacity = integrations[i].sendCapacity;
            integrations[i].send_success = integrations[i].sendSuccess;
            integrations[i].send_duplicate = integrations[i].sendDuplicate;
            integrations[i].send_error = integrations[i].sendError;
            integrations[i].send_capacity_duplicate = integrations[i].sendCapacityDuplicate;
            integrations[i].send_success_duplicate = integrations[i].sendSuccessDuplicate;
            integrations[i].remaining =
              integrations[i].send_capacity +
              integrations[i].send_capacity_duplicate -
              (integrations[i].send_success + integrations[i].send_success_duplicate);
          }

          this.$store.commit("lead/setIntegrationHistoryList", integrations);
          this.$store.commit("lead/setIntegrationHistory", res.data);

          const integrationsTab = res.data?.statistic?.integrations;
          this.tabIntegrationTotal = {
            send_counter: 0,
            send_capacity: 0,
            send_success: 0,
            send_duplicate: 0,
            send_error: 0,
            send_capacity_duplicate: 0,
            send_success_duplicate: 0,
            remaining: 0,
            ftd: 0,
            ftd_mtm: 0,
            cr: 0,
            cr_mtm: 0,
            success_sum: 0,
          };

          for (let i = 0; integrationsTab.length > i; i++) {
            this.tabIntegrationTotal.cr =
              this.tabIntegrationTotal.cr + Number(integrationsTab[i].cr || 0);
            this.tabIntegrationTotal.ftd = this.tabIntegrationTotal.ftd + integrationsTab[i].ftd;

            integrationsTab[i].ftd_mtm = integrationsTab[i].ftdMtm;
            this.tabIntegrationTotal.ftd_mtm =
              this.tabIntegrationTotal.ftd_mtm + integrationsTab[i].ftdMtm;

            integrationsTab[i].cr_mtm = integrationsTab[i].crMtm;
            this.tabIntegrationTotal.cr_mtm =
              this.tabIntegrationTotal.cr_mtm + Number(integrationsTab[i].crMtm || 0);

            integrationsTab[i].success_sum =
              integrationsTab[i].sendSuccess + integrationsTab[i].sendSuccessDuplicate;

            integrationsTab[i].integration_id = integrationsTab[i]?.integration?.name || "------";

            // валидные лиды: считаются только если у интеграции настроены валидные статусы партнёра
            const validStatuses = integrationsTab[i].validStatuses || [];
            const validLower = validStatuses.map((s) => String(s).trim().toLowerCase());
            integrationsTab[i].valid_statuses_list = validStatuses;
            integrationsTab[i].partner_statuses_list = (
              integrationsTab[i].partnerStatuses || []
            ).map((st) => ({
              ...st,
              isValid: validLower.includes(String(st.status).trim().toLowerCase()),
            }));
            integrationsTab[i].valid = validStatuses.length ? integrationsTab[i].valid || 0 : "—";
            integrationsTab[i].valid_percent = validStatuses.length
              ? `${integrationsTab[i].validPercent || 0}%`
              : this.$t("common.notSet");

            integrationsTab[i].send_counter = integrationsTab[i].sendCounter;
            this.tabIntegrationTotal.send_counter =
              this.tabIntegrationTotal.send_counter + integrationsTab[i].sendCounter;

            integrationsTab[i].send_capacity = integrationsTab[i].sendCapacity;
            this.tabIntegrationTotal.send_capacity =
              this.tabIntegrationTotal.send_capacity + integrationsTab[i].sendCapacity;

            integrationsTab[i].send_success = integrationsTab[i].sendSuccess;
            this.tabIntegrationTotal.send_success =
              this.tabIntegrationTotal.send_success + integrationsTab[i].sendSuccess;

            integrationsTab[i].send_duplicate = integrationsTab[i].sendDuplicate;
            this.tabIntegrationTotal.send_duplicate =
              this.tabIntegrationTotal.send_duplicate + integrationsTab[i].sendDuplicate;

            integrationsTab[i].send_error = integrationsTab[i].sendError;
            this.tabIntegrationTotal.send_error =
              this.tabIntegrationTotal.send_error + integrationsTab[i].sendError;

            integrationsTab[i].send_capacity_duplicate = integrationsTab[i].sendCapacityDuplicate;
            this.tabIntegrationTotal.send_capacity_duplicate =
              this.tabIntegrationTotal.send_capacity_duplicate +
              integrationsTab[i].sendCapacityDuplicate;

            integrationsTab[i].send_success_duplicate = integrationsTab[i].sendSuccessDuplicate;
            this.tabIntegrationTotal.send_success_duplicate =
              this.tabIntegrationTotal.send_success_duplicate +
              integrationsTab[i].sendSuccessDuplicate;

            integrationsTab[i].remaining =
              integrationsTab[i].send_capacity +
              integrationsTab[i].send_capacity_duplicate -
              (integrationsTab[i].send_success + integrationsTab[i].send_success_duplicate);
            this.tabIntegrationTotal.remaining =
              this.tabIntegrationTotal.remaining +
              integrationsTab[i].send_capacity +
              integrationsTab[i].send_capacity_duplicate -
              (integrationsTab[i].send_success + integrationsTab[i].send_success_duplicate);
          }

          this.tabIntegrationTotal.cr = integrationsTab.length
            ? Number((this.tabIntegrationTotal.cr / integrationsTab.length).toFixed(2))
            : 0;
          this.tabIntegrationTotal.cr_mtm = integrationsTab.length
            ? Number((this.tabIntegrationTotal.cr_mtm / integrationsTab.length).toFixed(2))
            : 0;

          this.tabIntegrationList = integrationsTab;

          // % Valid в итоге считает сервер — только по интеграциям с настроенными статусами
          this.tabIntegrationTotal.valid = res.data?.statistic?.valid || 0;
          this.tabIntegrationTotal.valid_percent = `${res.data?.statistic?.validPercent || 0}%`;

          const integrationsDate = res.data?.statistic?.dates;
          for (let i = 0; integrationsDate.length > i; i++) {
            integrationsDate[i].ftd_mtm = integrationsDate[i].ftdMtm;
            integrationsDate[i].cr_mtm = integrationsDate[i].crMtm;
            integrationsDate[i].success_sum =
              integrationsDate[i].sendSuccess + integrationsDate[i].sendSuccessDuplicate;

            integrationsDate[i].send_counter = integrationsDate[i].sendCounter;
            integrationsDate[i].send_capacity = integrationsDate[i].sendCapacity;
            integrationsDate[i].send_success = integrationsDate[i].sendSuccess;
            integrationsDate[i].send_duplicate = integrationsDate[i].sendDuplicate;
            integrationsDate[i].send_error = integrationsDate[i].sendError;
            integrationsDate[i].send_capacity_duplicate = integrationsDate[i].sendCapacityDuplicate;
            integrationsDate[i].send_success_duplicate = integrationsDate[i].sendSuccessDuplicate;
            integrationsDate[i].remaining =
              integrationsDate[i].send_capacity +
              integrationsDate[i].send_capacity_duplicate -
              (integrationsDate[i].send_success + integrationsDate[i].send_success_duplicate);
          }
          this.tabDateList = integrationsDate;
        })
        .catch((error) => {
          console.log(error);
          const { data } = error.response;
          this.$store.commit("lead/setError", data);
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    async getClient() {
      let url = "";
      await leadApi
        .getClientListAll(url)
        .then((res) => {
          this.clientList = res.data;
          console.log(this.clientList);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getIntegration() {
      await leadApi
        .getIntegrationAll()
        .then((res) => {
          this.integrationList = res.data;
          console.log(this.clientList);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getCountry() {
      await leadApi
        .getCountryList()
        .then((res) => {
          this.countriesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    filterList() {
      this.isFilter = true;
      this.handleSetQueryParams();
    },

    handleSetQueryParams() {
      const filter = {};

      if (this.filterData.bayer.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.bayer.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.bayer = ids.join(",");
        filter.bayer_name = name.join(",");
      }

      if (this.filterData.client.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.client.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.client = ids.join(",");
        filter.client_name = name.join(",");
      }

      if (this.filterData.languages.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.languages.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.code);
        });

        filter.languages = ids.join(",");
        filter.languages_name = name.join(",");
      }

      if (this.filterData.countries.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.countries.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.enName);
        });

        filter.countries = ids.join(",");
        filter.countries_name = name.join(",");
      }

      if (this.filterData.integration.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration = ids.join(",");
        filter.integration_name = name.join(",");
      }

      if (this.filterData.exclude_integration.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.exclude_integration.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.exclude_integration_id = ids.join(",");
        filter.exclude_integration_name = name.join(",");
      }

      if (this.filterData.integration_type.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration_type.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration_type = ids.join(",");
        filter.integration_type_name = name.join(",");
      }

      if (this.filterData.date_from != null) {
        filter.date_from = moment(this.filterData.date_from).format("YYYY-MM-DD");
      }

      if (this.filterData.date_to != null) {
        filter.date_to = moment(this.filterData.date_to).format("YYYY-MM-DD");
      }

      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.INTEGRATION_HISTORY.replace(":page", 1),
        });
      }
      this.$router.push({ name: "IntegrationHistoryList", query: filter });
    },
    setQueryParams() {
      if (this.handleGetQueryParam("bayer")) {
        const ids = this.handleGetQueryParam("bayer").split(",");
        const names = this.handleGetQueryParam("bayer_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.bayer.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("client")) {
        const ids = this.handleGetQueryParam("client").split(",");
        const names = this.handleGetQueryParam("client_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.client.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("languages")) {
        const ids = this.handleGetQueryParam("languages").split(",");
        const names = this.handleGetQueryParam("languages_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.languages.push({
            id: ids[index],
            code: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("countries")) {
        const ids = this.handleGetQueryParam("countries").split(",");
        const names = this.handleGetQueryParam("countries_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.countries.push({
            id: ids[index],
            enName: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration")) {
        const ids = this.handleGetQueryParam("integration").split(",");
        const names = this.handleGetQueryParam("integration_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("exclude_integration_id")) {
        const ids = this.handleGetQueryParam("exclude_integration_id").split(",");
        const names = this.handleGetQueryParam("exclude_integration_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.exclude_integration.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration_type")) {
        const ids = this.handleGetQueryParam("integration_type").split(",");
        const names = this.handleGetQueryParam("integration_type_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration_type.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_from")) {
        this.filterData.date_from = moment(
          this.handleGetQueryParam("date_from"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("date_to")) {
        this.filterData.date_to = moment(
          this.handleGetQueryParam("date_to"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      // по умолчанию — прошлая неделя (по ней в понедельник делают сверку валидных)
      if (!this.handleGetQueryParam("date_from") && !this.handleGetQueryParam("date_to")) {
        this.setPeriod("last_week");
      }

      this.getList();
    },
    getPeriodDates(key) {
      switch (key) {
        case "this_week":
          return [moment().startOf("isoWeek"), moment().startOf("day")];
        case "last_month": {
          const month = moment().subtract(1, "month");
          return [month.clone().startOf("month"), month.clone().endOf("month").startOf("day")];
        }
        default: {
          const week = moment().subtract(1, "week");
          return [week.clone().startOf("isoWeek"), week.clone().endOf("isoWeek").startOf("day")];
        }
      }
    },
    setPeriod(key) {
      const [from, to] = this.getPeriodDates(key);
      this.filterData.date_from = from.toDate();
      this.filterData.date_to = to.toDate();
      this.isFilter = true;
    },
    applyPeriodPreset(key) {
      this.setPeriod(key);
      this.filterList();
    },
    isPeriodPreset(key) {
      if (!this.filterData.date_from || !this.filterData.date_to) {
        return false;
      }
      const [from, to] = this.getPeriodDates(key);
      return (
        moment(this.filterData.date_from).isSame(from, "day") &&
        moment(this.filterData.date_to).isSame(to, "day")
      );
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },

    filterListReset() {
      this.isFilter = false;
      this.$router.push({ name: "IntegrationHistoryList", query: {} });
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.INTEGRATION_HISTORY.replace(":page", 1),
        });
      }
      this.filterData.integration = [];
      this.filterData.integration_type = [];
      this.filterData.exclude_integration = [];
      this.filterData.client = [];
      this.filterData.countries = [];
      this.filterData.languages = [];
      this.filterData.bayer = [];
      // сброс возвращает к периоду по умолчанию — прошлая неделя
      this.setPeriod("last_week");
      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    favoriteSwitch() {
      this.filterData.is_favorite = !this.filterData.is_favorite;
      localStorage.setItem("favorite_integration_switch", this.filterData.is_favorite);
      this.getList();
    },
    getCountFavorite() {
      let local = JSON.parse(localStorage.getItem("favorite_integration") || "[]");
      return local.length;
    },
    addAllCheckElement(key, array) {
      array.forEach((item, index) => {
        this.addCheckElement(key, item);
      });
    },
    addCheckElement(key, value) {
      const foundObj = this.filterData[key].find((obj) => obj.id == value.id);
      if (foundObj == undefined) {
        this.filterData[key].push(value);
      }
    },
    removeCheckElement(key, value) {
      this.filterData[key] = this.filterData[key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset) {
      console.log("hello");
      this.filterData[key] = reset;
    },
    handleTabChange(tab) {
      this.tab = tab;
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &.all {
      font-size: 18px;
      text-decoration: underline;
    }

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.5fr !important;
}

.integration-tab /deep/.custom-table__header,
.integration-tab /deep/.custom-table__row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr !important;
}

.list__filter-presets {
  display: flex;
  align-items: center;
  gap: 6px;
}

.list__filter-preset {
  padding: 6px 10px;
  border: 1px solid $mainDisabled;
  border-radius: 7px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;

  &.active {
    border-color: $mainColor;
    background: $mainColor;
    color: #fff;
  }
}

// вкладка Integration: + колонки Valid и % Valid
.integration-tab--valid /deep/.custom-table__header,
.integration-tab--valid /deep/.custom-table__row {
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.2fr !important;
}

.valid-explain {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid $mainDisabled;
  border-radius: 7px;
  font-size: 13px;

  &__title {
    font-weight: 700;
    cursor: pointer;
  }

  &__text {
    color: $mainSecondTextColor;
    padding: 6px 0 8px;
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
    padding: 6px 0;
    border-top: 1px solid $mainDisabled;
  }

  &__muted {
    color: $mainSecondTextColor;
  }

  &__statuses {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
  }

  &__status {
    padding: 1px 8px;
    border-radius: 99px;
    background: #f1f1f1;
    color: $mainSecondTextColor;

    &.valid {
      background: #e3f5ea;
      color: #1f7a45;
      font-weight: 600;
    }
  }
}

/deep/.modal-container {
  height: fit-content;
  max-height: 90vh;
  overflow-y: auto;
}

.list {
  &__count-element {
    font-size: 18px;
    font-weight: 700;
  }
  &__tab-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__tab {
    display: flex;
    border-radius: 20px;
    border: 1px solid #3c2a1e;
    width: fit-content;
  }
  &__tab-item {
    padding: 10px 20px;
    border-radius: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all ease-in-out 0.3s;

    &.active {
      background: #3c2a1e;
      color: #fff;
      transition: all ease-in-out 0.3s;
    }

    &.disable {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  &__filter-favorite {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    font-size: 18px;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }

    .inner {
      fill: #fff !important;
    }
    .border {
      stroke: rgb(148, 22, 22) !important;
      fill: none !important;
    }

    &.active {
      .inner {
        fill: rgb(148, 22, 22) !important;
      }
    }
  }
  &__confirm-log {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid gainsboro;
    margin-bottom: 10px;
  }

  &__confirm-log-type {
    padding: 20px;
    background: gainsboro;
    border-radius: 10px;
    margin-right: 10px;
  }

  &__confirm-log-time {
    margin-left: auto;
    padding-left: 10px;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
